/* SAELIA FR : fiche produit, panier, compte à rebours, date de livraison. Sans dépendance. */
(function () {
  var eur = function (c) { c = Math.round(c); var e = Math.floor(c / 100), d = ('0' + (c % 100)).slice(-2); return e + ',' + d + ' €'; };
  var $ = function (s, el) { return (el || document).querySelector(s); };
  var $$ = function (s, el) { return Array.prototype.slice.call((el || document).querySelectorAll(s)); };

  /* Galerie : vignettes <-> défilement */
  var gal = $('#sa-gal'), th = $$('#sa-th button');
  if (gal && th.length) {
    th.forEach(function (b) { b.addEventListener('click', function () { gal.scrollTo({ left: gal.clientWidth * +b.dataset.i, behavior: 'smooth' }); }); });
    gal.addEventListener('scroll', function () {
      var i = Math.round(gal.scrollLeft / gal.clientWidth);
      th.forEach(function (b, k) { b.classList.toggle('on', k === i); });
    }, { passive: true });
  }

  /* Packs */
  var packs = $$('#sa-packs .pack'), ups = $('#sa-ups');
  function pick(l) {
    packs.forEach(function (x) { x.classList.toggle('on', x === l); x.querySelector('input').checked = x === l; });
    var p = +l.dataset.price, c = +l.dataset.cmp;
    $('#sa-pnow').innerHTML = eur(p); $('#sa-atc-p').innerHTML = eur(p);
    var w = $('#sa-pwas'), s = $('#sa-psave');
    if (w) w.innerHTML = eur(c); if (s) s.innerHTML = 'Vous économisez ' + eur(c - p);
    var sp = $('#sa-stk-p'), sw = $('#sa-stk-w'); if (sp) sp.innerHTML = eur(p); if (sw) sw.innerHTML = eur(c);
    var pl = $('#sa-plabel b'); if (pl) pl.textContent = l.dataset.label;
    var pu = $('#sa-punit'); if (pu) { pu.hidden = l.dataset.qty !== '2'; pu.innerHTML = '2 ceintures, soit <b>' + eur(+l.dataset.unit) + ' la ceinture</b>'; }
    var sl = $('#sa-stk-l'); if (sl) sl.textContent = 'Ceinture SAELIA · ' + l.dataset.label;
    if (ups) { ups.hidden = l.dataset.kit === '1'; if (ups.hidden) $$('input', ups).forEach(function (i) { i.checked = false; }); }
    try { history.replaceState(null, '', location.pathname + '?variant=' + l.dataset.id + location.hash); } catch (e) {}
  }
  packs.forEach(function (l) { l.addEventListener('click', function (e) { e.preventDefault(); pick(l); }); });

  /* Ajout au panier : pack + cadeaux (garantie, e-book) + options cochées */
  var atc = $('#sa-atc');
  if (atc) atc.addEventListener('click', function () {
    var on = $('#sa-packs .pack.on'); if (!on) return;
    var n = +on.dataset.qty, items = [{ id: +on.dataset.id, quantity: 1 }];
    if (atc.dataset.gar) items.push({ id: +atc.dataset.gar, quantity: n });
    if (atc.dataset.ebook) items.push({ id: +atc.dataset.ebook, quantity: 1 });
    if (ups) $$('input:checked', ups).forEach(function (i) { items.push({ id: +i.value, quantity: 1 }); });
    atc.disabled = true; atc.firstChild.textContent = 'Ajout en cours… ';
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items })
    }).then(function (r) { if (!r.ok) throw r; location.href = atc.dataset.cart; })
      .catch(function () { atc.disabled = false; atc.firstChild.textContent = 'Ajouter au panier · '; alert("Désolé, l'ajout au panier n'a pas fonctionné. Réessayez ou écrivez-nous."); });
  });

  /* Barre collante mobile : visible une fois le bouton d'achat dépassé */
  var stk = $('#sa-stk');
  if (stk) {
    var ref = atc || $('.lp-cta');
    addEventListener('scroll', function () {
      var b = ref ? ref.getBoundingClientRect().bottom : 600;
      stk.classList.toggle('show', b < 0);
    }, { passive: true });
  }

  /* Animations (vidéos muettes en boucle) : lecture quand visibles */
  var vids = $$('video[autoplay]');
  if (vids.length && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { var v = e.target; if (e.isIntersecting) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); } else v.pause(); }); }, { rootMargin: '200px' });
    vids.forEach(function (v) { v.muted = true; io.observe(v); });
  }

  /* Compte à rebours honnête jusqu'à la fin réelle de l'offre */
  $$('.cd[data-end]').forEach(function (el) {
    var end = new Date(el.dataset.end).getTime();
    function t() {
      var s = Math.max(0, Math.floor((end - Date.now()) / 1000));
      if (!s) { el.textContent = ''; return; }
      var j = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600), m = Math.floor(s % 3600 / 60);
      el.textContent = ' · ' + (j ? j + ' j ' : '') + h + ' h' + (j ? '' : ' ' + ('0' + m).slice(-2) + ' min');
    }
    t(); setInterval(t, 30000);
  });

  /* Date de livraison estimée : 3 à 6 jours ouvrés */
  $$('.sa-eta2').forEach(function (e) {
    var ad = function (d, n) { d = new Date(d); while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w && w !== 6) n--; } return d; };
    var a = ad(new Date(), 3), b = ad(new Date(), 6), m = function (d) { return d.toLocaleDateString('fr-FR', { month: 'short' }); };
    e.textContent = 'reçue du ' + a.getDate() + (m(a) === m(b) ? '' : ' ' + m(a)) + ' au ' + b.getDate() + ' ' + m(b);
  });
  var eta = $$('.sa-eta');
  if (eta.length) {
    var add = function (d, n) { d = new Date(d); while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w && w !== 6) n--; } return d; };
    var f = function (d) { return d.toLocaleDateString('fr-FR', { weekday: 'short', day: 'numeric', month: 'short' }); };
    var now = new Date(), a = add(now, 3), b = add(now, 6);
    eta.forEach(function (e) { e.textContent = 'entre le ' + f(a) + ' et le ' + f(b); });
  }

  /* Panier : quantités, suppression, cadeaux liés à la ceinture */
  var cart = $('#sa-cart');
  if (cart) {
    var root = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
    var change = function (key, q) {
      cart.style.opacity = .5;
      return fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: q }) });
    };
    var sync = function () {
      return fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (c) {
        var belts = 0, gifts = [];
        c.items.forEach(function (i) { if (i.handle === 'saelia-ceinture-hanche') belts += i.quantity * (/2 ceintures/.test(i.variant_title || '') ? 2 : 1); if (i.final_price === 0) gifts.push(i); });
        var up = {};
        gifts.forEach(function (g) {
          var want = g.handle === 'saelia-garantie-5-ans' ? belts : (belts ? 1 : 0);
          if (g.quantity !== want) up[g.key] = want;
        });
        if (Object.keys(up).length) return fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: up }) });
      });
    };
    cart.addEventListener('click', function (e) {
      var b = e.target.closest('[data-q]'); if (!b) return;
      e.preventDefault();
      change(b.dataset.key, +b.dataset.q).then(sync).then(function () { location.reload(); });
    });
    $$('[data-add]', document).forEach(function (b) {
      b.addEventListener('click', function () {
        b.disabled = true;
        fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: +b.dataset.add, quantity: 1 }] }) })
          .then(function () { location.reload(); });
      });
    });
  }
})();
